import {i18n} from '@/plugins/i18n'

export const posStatuses = {
     PENDING : 0,
     ACTIVE :1,
     WAITING_TAX : 2,
     CORRECTION : 3,
     SWITCH : 4,
     SWITCH_ERROR : 5,
     SHAPARAK : 6,
     SHAPARAK_QUEUE : 7,
     SHAPARAK_ERROR : 8,
     AGENCY : 9,
     PSP_VISITOR : 10,
     INDICATOR_TRANSACTION : 11,
     COMPLETING_DOCUMENTS : 12,
     END_OF_FLOW : 13,
     DISCARDED  :14,
     CANCELING : 15,
     POS_REQUEST  :16,
     CHANGE_ACCOUNT : 17,
     EDIT_REQUEST : 18,
     BIND_SERIAL_TO_SWITCH : 19,
     CUSTOMER_UPDATE : 20,
     ROLLBACK : 21,
     POS_REPLACEMENT : 22,
     PROVIDE_INVENTORY : 23,
     AGENCY_CHECK : 24,
     REQUEST_SENT : 25,
     FINAL_REJECT : 26,
     AGENCY_DISABLE_CHECK : 27,
     DISABLE : 28
}

export const posStatusStr = {
    PENDING: i18n.t('pos.statuses.Pending'),
    ACTIVE: i18n.t('pos.statuses.Active'),
    CORRECTION: i18n.t('pos.statuses.Correction'),
    PSP_VISITOR: i18n.t('pos.statuses.PSPVisitor'),
    WAITING_TAX: i18n.t('pos.statuses.WaitingTax'),
    SWITCH: i18n.t('pos.statuses.Switch'),
    SWITCH_ERROR: i18n.t('pos.statuses.SwitchError'),
    SHAPARAK: i18n.t('pos.statuses.Shaparak'),
    SHAPARAK_QUEUE: i18n.t('pos.statuses.ShaparakQueue'),
    SHAPARAK_ERROR: i18n.t('pos.statuses.ShaparakError'),
    AGENCY: i18n.t('pos.statuses.Agency'),
    BIND_SERIAL_TO_SWITCH: i18n.t('pos.statuses.BindSerialToSwitch'),
    INDICATOR_TRANSACTION: i18n.t('pos.statuses.IndicatorTransaction'),
    COMPLETING_DOCUMENTS: i18n.t('pos.statuses.CompletingDocuments'),
    END_OF_FLOW: i18n.t('pos.statuses.EndOfFlow'),
    DISCARDED: i18n.t('pos.statuses.Discarded'),
    CANCELING: i18n.t('pos.statuses.Canceling'),
    POS_REQUEST: i18n.t('pos.statuses.PosRequest'),
    CHANGE_ACCOUNT: i18n.t('pos.statuses.ChangeAccount'),
    EDIT_REQUEST: i18n.t('pos.statuses.EditRequest'),
    CUSTOMER_CREATED: i18n.t('pos.statuses.CustomerCreated'),
    CUSTOMER_UPDATE: i18n.t('pos.statuses.CustomerUpdate'),
    ROLLBACK: i18n.t('pos.statuses.Rollback'),
    POS_REPLACEMENT: i18n.t('pos.statuses.PosReplacement'),
    PROVIDE_INVENTORY: i18n.t('pos.statuses.ProvideInventory'),
    AGENCY_CHECK: i18n.t('pos.statuses.AgencyCheck'),
    REQUEST_SENT: i18n.t('pos.statuses.RequestSent'),
    FINAL_REJECT: i18n.t('pos.statuses.FinalReject'),
    AGENCY_DISABLE_CHECK: i18n.t('pos.statuses.AgencyDisableCheck'),
    DISABLE: i18n.t('pos.statuses.Disable'),
    get(status) {
        let status_str = null;
        Object.keys(posStatuses).forEach(function (item, index) {
            if (posStatuses[item] === status) {
                status_str = posStatusStr[item]
            }
        })

        return status_str
    }
}
export const managerCanEditDocuments =[
    posStatuses.PENDING,
    posStatuses.AGENCY_CHECK,
    posStatuses.CORRECTION,
    posStatuses.REQUEST_SENT,

];
export const visitorCanEditDocuments =[
    posStatuses.PENDING,
    posStatuses.CORRECTION,
];
export const managerCanUpdateRequest =[
    posStatuses.SWITCH,
    posStatuses.REQUEST_SENT,
    posStatuses.PSP_VISITOR,
    posStatuses.AGENCY,
    posStatuses.BIND_SERIAL_TO_SWITCH,
    posStatuses.WAITING_TAX,

];
export const visitorCanUpdateRequest =[
    posStatuses.REQUEST_SENT,
    posStatuses.PSP_VISITOR,
    posStatuses.AGENCY,
    posStatuses.BIND_SERIAL_TO_SWITCH,
    posStatuses.WAITING_TAX,
];

export const manageDocuments ={
    WATCH : 1,
    EDIT : 2,
    UPLOAD : 3,
};


export const deviceStatus = {
    PENDING: 1,
    ADDED: 2,
    REPLACED: 3,
    ALLOCATED: 4,
    REPLACEING: 5,
    ACTIVE: 6,
    REJECTED: 7,
    BLOCKED: 8
};


export const posVariant = (status) => {
    return (status === posStatuses.END_OF_FLOW)
        ? 'success'
        : (
            (status === posStatuses.PENDING || status === posStatuses.CORRECTION || status === posStatuses.AGENCY_CHECK)
                ? 'warning'
                : 'danger'
        )
} 